var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 50,
    viewBox: "0 0 170 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9505_36096)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.278442,
    width: 168.75,
    height: 50,
    rx: 6,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.776 50H6.53074C3.08484 50 0.278442 47.182 0.278442 43.75V6.25C0.278442 2.80549 3.08484 0 6.53074 0H162.776C166.219 0 169.028 2.80549 169.028 6.25V43.75C169.028 47.182 166.219 50 162.776 50Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M89.1764 16.5399C88.0495 16.5399 87.0996 16.1441 86.3483 15.3648C85.6032 14.6073 85.1872 13.563 85.2059 12.4969C85.2059 11.3592 85.5908 10.3959 86.3483 9.63222C87.0965 8.85292 88.0464 8.45703 89.1733 8.45703C90.2878 8.45703 91.2377 8.85292 92.0014 9.63222C92.7589 10.4209 93.1438 11.3841 93.1438 12.4969C93.1314 13.6378 92.7465 14.601 92.0014 15.3616C91.2532 16.1472 90.3033 16.5399 89.1764 16.5399ZM55.6458 16.5399C54.5437 16.5399 53.5876 16.1503 52.8052 15.3803C52.0291 14.6135 51.6349 13.6441 51.6349 12.5C51.6349 11.356 52.0291 10.3866 52.8052 9.61975C53.572 8.8498 54.5282 8.46015 55.6458 8.46015C56.1921 8.46015 56.723 8.56925 57.2321 8.79057C57.7319 9.00566 58.1386 9.29868 58.4397 9.65716L58.5142 9.74756L57.6729 10.5767L57.586 10.4739C57.111 9.90653 56.4746 9.6291 55.6334 9.6291C54.8821 9.6291 54.2271 9.89718 53.6869 10.4271C53.1436 10.9601 52.8673 11.6584 52.8673 12.5032C52.8673 13.3479 53.1436 14.0462 53.6869 14.5792C54.2271 15.1092 54.8821 15.3772 55.6334 15.3772C56.4343 15.3772 57.1079 15.1092 57.6326 14.5792C57.943 14.2675 58.1355 13.8311 58.2038 13.2794H55.5061V12.1135H59.3617L59.3773 12.2195C59.4052 12.4159 59.4331 12.6185 59.4331 12.8055C59.4331 13.881 59.1103 14.7507 58.4708 15.3928C57.7443 16.1534 56.7944 16.5399 55.6458 16.5399ZM100.228 16.3747H99.0391L95.3976 10.5237L95.4287 11.5774V16.3716H94.2397V8.62536H95.5963L95.6336 8.68459L99.0577 14.1958L99.0267 13.1453V8.62536H100.228V16.3747ZM80.2419 16.3747H79.0374V9.7912H76.9482V8.62536H82.3281V9.7912H80.2388V16.3747H80.2419ZM75.9672 16.3747H74.7658V8.62536H75.9672V16.3747ZM69.2151 16.3747H68.0137V9.7912H65.9244V8.62536H71.3044V9.7912H69.2151V16.3747ZM65.1639 16.3623H60.5569V8.62536H65.1639V9.7912H61.7614V11.9171H64.8317V13.0705H61.7614V15.1964H65.1639V16.3623ZM87.2299 14.5636C87.767 15.1029 88.4189 15.3741 89.1764 15.3741C89.9556 15.3741 90.592 15.1092 91.1229 14.5636C91.6506 14.0337 91.9176 13.3386 91.9176 12.5C91.9176 11.6615 91.6506 10.9633 91.126 10.4365C90.5889 9.89718 89.9339 9.62598 89.1795 9.62598C88.4003 9.62598 87.7639 9.89095 87.2362 10.4365C86.7084 10.9664 86.4414 11.6615 86.4414 12.5C86.4414 13.3386 86.7053 14.0368 87.2299 14.5636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0942 27.1931C82.1605 27.1931 79.7825 29.4281 79.7825 32.511C79.7825 35.5659 82.1761 37.829 85.0942 37.829C88.0279 37.829 90.4059 35.5783 90.4059 32.511C90.4059 29.4281 88.0279 27.1931 85.0942 27.1931ZM85.0942 35.7217C83.4892 35.7217 82.1078 34.3876 82.1078 32.4985C82.1078 30.5815 83.4923 29.2753 85.0942 29.2753C86.6992 29.2753 88.0807 30.5815 88.0807 32.4985C88.0838 34.4 86.6992 35.7217 85.0942 35.7217ZM73.5054 27.1931C70.5717 27.1931 68.1937 29.4281 68.1937 32.511C68.1937 35.5659 70.5872 37.829 73.5054 37.829C76.4391 37.829 78.8171 35.5783 78.8171 32.511C78.8171 29.4281 76.436 27.1931 73.5054 27.1931ZM73.5054 35.7217C71.9004 35.7217 70.519 34.3876 70.519 32.4985C70.519 30.5815 71.9035 29.2753 73.5054 29.2753C75.1104 29.2753 76.4919 30.5815 76.4919 32.4985C76.4919 34.4 75.1104 35.7217 73.5054 35.7217ZM59.7156 28.8171V31.0677H65.0955C64.931 32.3302 64.515 33.2623 63.8786 33.9013C63.0901 34.6931 61.8731 35.5534 59.728 35.5534C56.4218 35.5534 53.8358 32.8726 53.8358 29.5528C53.8358 26.233 56.4218 23.5522 59.728 23.5522C61.513 23.5522 62.8138 24.2598 63.7792 25.1637L65.3687 23.5677C64.0276 22.2772 62.2426 21.2891 59.7404 21.2891C55.2048 21.2891 51.3988 24.9985 51.3988 29.5403C51.3988 34.0945 55.2017 37.7916 59.7404 37.7916C62.1898 37.7916 64.0276 36.9873 65.4805 35.4724C66.9613 33.9854 67.43 31.8876 67.43 30.1949C67.43 29.6681 67.3897 29.1943 67.3059 28.7922H59.7125C59.7156 28.7891 59.7156 28.8171 59.7156 28.8171ZM116.12 30.569C115.676 29.3751 114.335 27.1806 111.584 27.1806C108.859 27.1806 106.592 29.3346 106.592 32.4985C106.592 35.4848 108.834 37.8165 111.848 37.8165C114.27 37.8165 115.679 36.3296 116.26 35.4568L114.462 34.2473C113.866 35.1357 113.037 35.7186 111.861 35.7186C110.672 35.7186 109.84 35.1762 109.287 34.107L116.368 31.1613C116.368 31.1644 116.12 30.569 116.12 30.569ZM108.899 32.3458C108.843 30.2916 110.488 29.2473 111.665 29.2473C112.593 29.2473 113.366 29.7055 113.63 30.3726L108.899 32.3458ZM103.146 37.4985H105.472V21.8751H103.146V37.4985ZM99.328 28.3745H99.2442C98.7195 27.7479 97.723 27.1806 96.4502 27.1806C93.8083 27.1806 91.3745 29.5154 91.3745 32.5141C91.3745 35.5004 93.7959 37.8071 96.4502 37.8071C97.7075 37.8071 98.7195 37.2367 99.2442 36.5977H99.328V37.3614C99.328 39.3907 98.2477 40.4848 96.5061 40.4848C95.0811 40.4848 94.1964 39.4561 93.8363 38.5958L91.8153 39.4437C92.3958 40.8464 93.9449 42.5827 96.503 42.5827C99.2287 42.5827 101.538 40.9711 101.538 37.0403V27.4985H99.3404V28.3745C99.3435 28.3745 99.328 28.3745 99.328 28.3745ZM96.6582 35.7217C95.0532 35.7217 93.7121 34.3751 93.7121 32.5141C93.7121 30.6376 95.0532 29.2785 96.6582 29.2785C98.2477 29.2785 99.4801 30.6532 99.4801 32.5141C99.4956 34.3751 98.2508 35.7217 96.6582 35.7217ZM127.007 21.8751H121.447V37.4985H123.772V31.5821H127.01C129.584 31.5821 132.114 29.7086 132.114 26.7348C132.114 23.761 129.593 21.8751 127.007 21.8751ZM127.075 29.4H123.769V24.0384H127.075C128.817 24.0384 129.801 25.4817 129.801 26.7192C129.801 27.9443 128.804 29.4 127.075 29.4ZM141.433 27.165C139.744 27.165 138.003 27.9162 137.283 29.5528L139.344 30.4131C139.788 29.5528 140.601 29.2598 141.461 29.2598C142.666 29.2598 143.883 29.983 143.911 31.2735V31.4387C143.495 31.2018 142.582 30.8402 141.489 30.8402C139.263 30.8402 137.006 32.0621 137.006 34.3533C137.006 36.4512 138.832 37.7978 140.865 37.7978C142.427 37.7978 143.287 37.0902 143.824 36.2704H143.908V37.4798H146.149V31.4948C146.149 28.708 144.088 27.165 141.433 27.165ZM141.141 35.7217C140.381 35.7217 139.316 35.3477 139.316 34.3876C139.316 33.1781 140.645 32.7199 141.778 32.7199C142.802 32.7199 143.287 32.9412 143.895 33.2467C143.727 34.6494 142.548 35.7093 141.141 35.7217ZM154.326 27.4985L151.656 34.2753H151.572L148.806 27.4985H146.304L150.455 36.9717L148.089 42.2367H150.511L156.896 27.4985H154.326ZM133.396 37.4985H135.721V21.8751H133.396V37.4985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2673 9.41815C12.9072 9.8078 12.6992 10.4032 12.6992 11.1825V38.8228C12.6992 39.6021 12.9072 40.1975 13.2797 40.5715L13.376 40.6557L28.7987 25.1694V24.8234L13.3636 9.33398L13.2673 9.41815Z",
    fill: "url(#paint0_linear_9505_36096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9302 30.3463L28.7861 25.1811V24.8195L33.9302 19.6543L34.0419 19.7229L40.1266 23.1954C41.8682 24.1805 41.8682 25.8077 40.1266 26.8052L34.0419 30.2777L33.9302 30.3463Z",
    fill: "url(#paint1_linear_9505_36096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0421 30.2774L28.7863 25L13.2673 40.5829C13.8354 41.1939 14.7885 41.2625 15.8533 40.6671L34.0421 30.2774Z",
    fill: "url(#paint2_linear_9505_36096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0421 19.7221L15.8533 9.348C14.7885 8.73703 13.8323 8.82119 13.2673 9.43217L28.7863 24.9995L34.0421 19.7221Z",
    fill: "url(#paint3_linear_9505_36096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9304 30.166L15.8657 40.4715C14.8567 41.0544 13.9564 41.0139 13.3759 40.4839L13.2797 40.5806L13.3759 40.6647C13.9564 41.1915 14.8567 41.2352 15.8657 40.6523L34.0545 30.2782L33.9304 30.166Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1267 26.6241L33.9148 30.1652L34.0266 30.2774L40.1112 26.8049C40.9836 26.3061 41.412 25.6515 41.412 25C41.3592 25.5985 40.9153 26.1658 40.1267 26.6241Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8533 9.53034L40.1268 23.377C40.9153 23.8227 41.3592 24.4057 41.4275 25.001C41.4275 24.3495 40.9991 23.6949 40.1268 23.1962L15.8533 9.34954C14.1117 8.34892 12.6992 9.18433 12.6992 11.1825V11.3633C12.6992 9.36201 14.1117 8.54218 15.8533 9.53034Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9505_36096",
    x1: 27.4153,
    y1: 10.8843,
    x2: 2.69733,
    y2: 17.4434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9505_36096",
    x1: 42.3978,
    y1: 25.0004,
    x2: 12.2757,
    y2: 25.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9505_36096",
    x1: 31.1842,
    y1: 27.8717,
    x2: 11.2308,
    y2: 61.3173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9505_36096",
    x1: 9.35948,
    y1: 0.222988,
    x2: 18.2616,
    y2: 15.1604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9505_36096"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.278442,
    width: 168.75,
    height: 50,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ee0806519abe6ce3f702b98363029b96.svg";
export { ForwardRef as ReactComponent };